<template>
    <div>
        <BaseCard>
            <template #card-body>
                <div>
                    <slot name="header-caption" />

                    <div class="report__percentage">
                        <div v-for="item in statusData" :key="item.id" class="report__percentage__item flex align-items-center">
                            <span class="text--sm mr--10 text-gray-600 text--capitalize">{{ item.id }}:</span>
                            <span class="stats__rate green" style="background: rgb(217, 237, 219, 0.7)">{{ item.percentageValue }}%</span>
                        </div>
                    </div>
                </div>
            </template>
        </BaseCard>
    </div>
</template>

<script>
import { BaseCard } from "@/components/ui/index";

export default {
    name: "StatusReport",

    components: {
        BaseCard,
    },

    props: {
        statusData: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
       
    },

    methods: {
    },
};
</script>

<style lang="scss" scoped>
    .report__percentage {
        display: grid;
        gap: 5px 10px;
        
        &__item { 
            width: 100%;
            padding: 5px 0;
        }
    }
</style>